



import ITourDto from "./TourDto.if";
import mappings from "./TourDto.map";

import Transformers from './private/transformer';
import DBUtils from './private/db.util';
import { IModelSource } from "./private/db.if";

import ISiteDto from "./SiteDto.if";
import SiteDto from "./SiteDto";
import ITourTypeDto from "./TourTypeDto.if";
import TourTypeDto from "./TourTypeDto";
import ITourSubTypeDto from "./TourSubTypeDto.if";
import TourSubTypeDto from "./TourSubTypeDto";
import ITourStatusDto from "./TourStatusDto.if";
import TourStatusDto from "./TourStatusDto";
import IStyleDto from "./StyleDto.if";
import StyleDto from "./StyleDto";
import ITourSupportedLanguageDto from "./TourSupportedLanguageDto.if";
import TourSupportedLanguageDto from './TourSupportedLanguageDto';
import ITourTranslationDto from "./TourTranslationDto.if";
import TourTranslationDto from './TourTranslationDto';
import ISiteSupportedLanguageDto from "./SiteSupportedLanguageDto.if";
import SiteSupportedLanguageDto from './SiteSupportedLanguageDto';
import ILanguageDto from "./LanguageDto.if";


function _site(this: ITourDto, db: IModelSource): Promise<ISiteDto> {
    return DBUtils.loadSiteId<ISiteDto>(db, this.siteId, SiteDto);
}

function _tourType(this: ITourDto, db: IModelSource): Promise<ITourTypeDto> {
    return DBUtils.loadTourTypeId<ITourTypeDto>(db, this.tourTypeId, TourTypeDto);
}

function _tourSubType(this: ITourDto, db: IModelSource): Promise<ITourSubTypeDto> {
    return DBUtils.loadTourSubTypeId<ITourSubTypeDto>(db, this.tourSubTypeId, TourSubTypeDto);
}

function _style(this: ITourDto, db: IModelSource): Promise<IStyleDto> {
    return DBUtils.loadStyleId<IStyleDto>(db, this.styleId, StyleDto);
}

function _tourStatus(this: ITourDto, db: IModelSource): Promise<ITourStatusDto> {
    return DBUtils.loadTourStatusId<ITourStatusDto>(db, this.tourStatusId, TourStatusDto);
}

function _tourSupportedLanguages(this: ITourDto, db: IModelSource): Promise<Array<ITourSupportedLanguageDto>> {
    const self = this;

    return new Promise(function(resolve, reject) {
        DBUtils.allTourSupportedLanguages<ITourSupportedLanguageDto>(db, TourSupportedLanguageDto)
            .then(function(allTourSupportedLanguages) {
                const match = allTourSupportedLanguages.filter(x => x.tourId === self.id);
                resolve(match);
            })
            .catch(error => reject(error));
    });
}

function _translations(this: ITourDto, db: IModelSource): Promise<Array<ITourTranslationDto>> {
    const self = this;

    return new Promise(async function(resolve, reject) {
        try {
            const matchTSL = await self.tourSupportedLanguages(db);
            const matchTSLIds = matchTSL.map(x => x.id);
            const allTranslations = await DBUtils.allTourTranslations<ITourTranslationDto>(db, TourTranslationDto);
            const matchTranslations = allTranslations.filter(x => matchTSLIds.includes(x.tourSupportedLanguageId));

            resolve(matchTranslations);
        } catch (error) {
            reject(error);
        }
    });
}

function _translation(this: ITourDto, db: IModelSource, language: ILanguageDto|Number): Promise<ITourTranslationDto> {
    const self = this;

    const languageId: Number = 
        ((language as ILanguageDto)?.id != undefined) ?
            Number((language as ILanguageDto).id ?? -1) :
            Number(language);

    return new Promise(async function(resolve, reject) {
        try {
            const allSSL = await DBUtils.allSiteSupportedLanguages<ISiteSupportedLanguageDto>(db, SiteSupportedLanguageDto);
            const matchSSL = allSSL.filter(x => x.languageId === languageId);
            const matchSSLIds = matchSSL.map(x => x.id);
            const allTSL = await self.tourSupportedLanguages(db);
            const matchTSL = allTSL.filter(x => matchSSLIds.includes(x.siteSupportedLanguageId));
            const matchTSLIds = matchTSL.map(x => x.id);
            const allTranslations = await self.translations(db);
            const matchTranslations = allTranslations.filter(x => matchTSLIds.includes(x.tourSupportedLanguageId));

            ( matchTranslations.length > 0 ) ?
                resolve(matchTranslations[0]) :
                reject('Unable to find translation for languageId:' + languageId + ' for tourId:' + self.id);
        } catch (error) {
            reject(error);
        }
    });
}

export default (data: object) => { 
    const obj = Transformers.create<ITourDto>(mappings, data);

    /* addLinkables */
    obj.site = _site;
    obj.tourType = _tourType;
    obj.tourSubType = _tourSubType;
    obj.style = _style;
    obj.tourStatus = _tourStatus;

    obj.tourSupportedLanguages = _tourSupportedLanguages;
    obj.translations = _translations;
    obj.translation = _translation;

    return obj;
}

